<script lang="ts">
	import { addNotification } from '../../notification/Notificationstore';
	import type { UploadLink } from '../../types/ProductTypes';
	import { _ } from 'svelte-i18n';
	import Icon from '../Icon.svelte';
	import DataLoadingAnimation from '../loading/DataLoadingAnimation.svelte';
	import { uploadFile } from './UploadDocumentAttachmentHelper';

	let input: HTMLInputElement | undefined = $state();
	let loading = $state(false);

	interface Props {
		disableUpload?: boolean;
		uploadName: string | null;
		acceptedFileTypes: string;
		iconSize?: 'huge' | 'big' | 'normal' | 'small';
		displayText: string;
		getUploadLink: () => Promise<UploadLink>;
		fileTypeCheck: (type: String) => Boolean;
		maxFileSize?: number; //default cap
		confirmFunction: (uploadName: string, objectName: string) => Promise<void>;
		onUploadSuccess?: () => void;
	}

	let {
		disableUpload = false,
		uploadName,
		acceptedFileTypes,
		iconSize = 'huge',
		displayText,
		getUploadLink,
		fileTypeCheck,
		maxFileSize = 1024 * 1024 * 15,
		confirmFunction,
		onUploadSuccess
	}: Props = $props();

	function handleDrop(e: DragEvent) {
		e.preventDefault();
		const item = e.dataTransfer?.files[0];

		if (item == null) return;

		if (fileTypeCheck(item.type)) {
			onDrop(item);
		} else {
			addNotification({
				type: 'error',
				message: $_('general.import.err_file_wrong_content_type').replace('{}', acceptedFileTypes)
			});
		}
	}

	const onDrop = (file: File) => {
		loading = true;
		//Start the upload
		uploadFile(
			file,
			null,
			maxFileSize,
			getUploadLink,
			confirmFunction,
			() => {
				//Close the modal
				onUploadSuccess?.();
				//Set the loading back to none
				loading = false;
				//Reset the value
				if (input) {
					input.value = '';
				}
			},
			() => {
				//Set the loading back to none
				loading = false;
			}
		);
	};

	const handleChange = (e: any) => {
		e.preventDefault();
		onDrop(e.target.files[0]);
	};
</script>

<button
	class="w-full"
	ondrop={(e) => {
		if (disableUpload) return;
		else handleDrop(e);
	}}
	ondragover={(e) => e.preventDefault()}
	disabled={loading || disableUpload}
	onclick={() => input?.click()}
>
	<div
		id="fallback "
		class="border-4 rounded-lg border-dashed grid justify-items-center gap-2 p-4 {disableUpload
			? 'bg-gray border-gray'
			: 'border-secondary-300 dark:border-secondary-500'}"
	>
		{#if loading}
			<div class="w-36 h-36 justify-self-center">
				<DataLoadingAnimation showData={loading} />
			</div>
		{:else}
			<Icon name="upload" size={iconSize} classInfo="dark:fill-white" />
			<div class="bottom-2 text-center text-black">
				{displayText}
			</div>
		{/if}
	</div>

	<input
		type="file"
		class="hidden"
		disabled={disableUpload}
		accept={acceptedFileTypes}
		onchange={handleChange}
		bind:this={input}
	/>
</button>
